<template>
    <div id="order-search-results"
         class="search-results-list order-results-list">
        <div class="order-search-results__title desktop-only">
            <h3 v-if="searchCriteria.sessionWithEvent"
                class="text-white">
                {{ orders.length }}
                {{ l(orders.length === 1 ? 'ORDERS.RESULTS_TITLE_WITH_SESSION_ONE' : 'ORDERS.RESULTS_TITLE_WITH_SESSION') }}
                <em>{{ searchCriteria.sessionWithEvent.event.name }}</em>
                <br />
                <small>
                    {{ sessionFullName }}
                </small>
            </h3>
            <h3 v-else
                class="text-white">
                {{ orders.length }}
                {{ l(orders.length === 1 ? 'ORDERS.RESULTS_TITLE_ONE' : 'ORDERS.RESULTS_TITLE') }}
            </h3>

            <h4 v-if="results && results.requestIsPending">
                <i class="fa-solid fa-spinner fa-spin"></i>
                {{ l('ORDERS.MORE_RESULTS_LOADING') }}
            </h4>
        </div>

        <OrdersList :orders="currentPageOrders"
                    :redeem-session="redeemSession" />
    </div>
</template>

<script>
import OrdersList from '@/epos/vue/components/Orders/OrdersList';

export default {
    name: 'OrderSearchResults',

    components: { OrdersList },

    props: {
        currentPage: {
            type: Number,
            required: true,
        },

        pageSize: {
            type: Number,
            required: true,
        },

        results: {
            type: Object,
            required: true,
        },

        /**
         * @type {OrderSearchCriteria}
         */
        searchCriteria: {
            type: Object,
            required: true,
        },
    },

    computed: {
        orders() {
            return this.results.orders;
        },

        currentPageOrders() {
            return this.orders.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize,
            );
        },

        redeemSession() {
            return this.searchCriteria.sessionWithEvent || null;
        },

        sessionFullName() {
            if (
                this.searchCriteria.sessionWithEvent
                && this.searchCriteria.sessionWithEvent.session.name !== this.searchCriteria.sessionWithEvent.event.name
            ) {
                return this.searchCriteria.sessionWithEvent.session.getFullName();
            }

            return null;
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";

#order-search-results {
    .order-search-results__title {
        display: flex;
        align-items: center;
        margin: 15px 0;

        > h3 {
            flex-grow: 1;
            margin: 0;
        }

        > h4 {
            margin: 0;
            padding: 0;
            color: @white;
            font-size: 12px;
            opacity: .8;
        }
    }
}
</style>
